var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaptainCap2 = function SvgCaptainCap2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 33h40v3H12zM12 38h40v3H12zM54.69 46.242a47.9 47.9 0 0 1-45.38 0l-.774 1.219a1.003 1.003 0 0 0 .304 1.386c13.145 8.204 33.175 8.204 46.32 0a1.003 1.003 0 0 0 .304-1.386z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.385 44.546a45.89 45.89 0 0 0 43.23 0L52.635 43h-41.27z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 16,
    r: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9C15.73 9 2 22.331 2 30.704a5.54 5.54 0 0 0 1.633 4.089c1.374 1.363 3.563 2.163 6.367 2.634V32a1 1 0 0 1 1-1h42a1 1 0 0 1 1 1v5.429c2.806-.471 4.992-1.273 6.367-2.636A5.54 5.54 0 0 0 62 30.704C62 22.331 48.27 9 32 9m1 18.91V28a1 1 0 0 1-2 0v-.09A6.005 6.005 0 0 1 26 22a1 1 0 0 1 2 0 3.996 3.996 0 0 0 3 3.858V22h-1a1 1 0 0 1 0-2h1v-1.184a3 3 0 1 1 2 0V20h1a1 1 0 0 1 0 2h-1v3.858A3.996 3.996 0 0 0 36 22a1 1 0 0 1 2 0 6.005 6.005 0 0 1-5 5.91"
  })));
};
export default SvgCaptainCap2;